// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__35wUC","productName":"Table_productName__2-qrT"};